module.exports = __webpack_public_path__ + "images/68feb5ae65cef440cfe21eeebc0a89f0-colorPal.svg";